import React from 'react';
import { Card } from "react-bootstrap";
import face_balazs_pejo from "../../assets/img/face_balazs_pejo.jpg";
import ShowMoreText from "react-show-more-text";
import proj_image from "../../assets/img/projPejoB_secure_private.png";

const Balazs_Pejo_secure_private = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_image} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_balazs_pejo}
              /* this will be the text on the banner */
              alt="Secure and Private Contribution Evaluation in Federated Learning"
            />{" "}
            <p className="text7">Balázs Pejó</p>
            <br />
            <p className="text8">
              Assistant Professor{" "}
            </p>
            <p className="text8">Laboratory of Cryptography and Systems Security, HIT-VIK-BME</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            Working on this OTKA PD project allows students to tackle one of the most pressing challenges in modern AI: 
            quantifying the true value of participant data while maintaining strict privacy and security. By exploring 
            the intersection of Federated Learning and game-theoretic concepts like Shapley Values, you will develop 
            hands-on expertise in PyTorch, TensorFlow, and privacy-preserving technologies such as Differential Privacy 
            and Secure Aggregation. This research offers a unique intellectual challenge — solving the inherent 
            trade-offs between data utility and protection — and serves as a high-impact launchpad for a career in 
            top-tier AI research or the global tech industry, where building fair and trustworthy collaborative systems 
            is now a critical priority.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Balazs_Pejo_secure_private;